import BaseModule from '../../../../javascripts/helpers/baseModule';
import addClass from '../../../../javascripts/dom/addClass';
import removeClass from '../../../../javascripts/dom/removeClass';
import forEach from '../../../../javascripts/dom/forEach';

const mediaCopyModules = document.querySelectorAll("[data-js-module='o-media-copy']");

class MediaCopy extends BaseModule {
  constructor(element) {
    super(element, 'o-media-copy');

    this.figureInViewportClass = 'o-media-copy__figure--is-in-viewport';

    this.getElements([
      {
        id: 'figure',
        selector: 'figure'
      },
      {
        id: 'matomoframe',
        selector: 'matomoframe'
      }
    ]);

    if (this.elements.figure) {
      this.attachFigureWaypoint();
    }

    if (this.elements.matomoframe) {
      window.addEventListener(
        'message',
        e => {
          this.elements.matomoframe.style.height = `${e.data}px`;
        },
        false
      );
    }
  }

  attachFigureWaypoint() {
    new window.Waypoint({
      element: this.elements.figure,
      handler: direction => {
        if (direction === 'down') {
          addClass(this.elements.figure, this.figureInViewportClass);
        } else {
          removeClass(this.elements.figure, this.figureInViewportClass);
        }
      },
      offset: () => window.Waypoint.viewportHeight() - this.elements.figure.clientHeight * 0.5
    });
  }
}

if (mediaCopyModules.length) {
  forEach(mediaCopyModules, (index, element) => {
    new MediaCopy(element);
  });
}
